import React, { useEffect, useState } from "react";
import { designWidth, designHeight } from "../constants";

// Het dashboard is getekend op 1920x1080. Deze wrapper schaalt dat vlak naar
// het echte scherm, zodat het altijd precies past en er nooit scrollbalken
// verschijnen.

const outer = {
  width: "100vw",
  height: "100vh",
  overflow: "hidden",
  position: "relative",
  backgroundColor: "#0f2f47",
};

const ScaledCanvas = ({ children }) => {
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const onResize = () =>
      setViewport({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const scale = Math.min(
    viewport.width / designWidth,
    viewport.height / designHeight,
  );
  // Wat overblijft verdelen we links/rechts en boven/onder, zodat het
  // dashboard midden op het scherm staat.
  const offsetX = (viewport.width - designWidth * scale) / 2;
  const offsetY = (viewport.height - designHeight * scale) / 2;

  return (
    <div style={outer}>
      <div
        style={{
          width: `${designWidth}px`,
          height: `${designHeight}px`,
          transform: `translate(${offsetX}px, ${offsetY}px) scale(${scale})`,
          transformOrigin: "top left",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ScaledCanvas;
